<template>
  <div class="applicationCenter-wrap">
    <div class="applicationCenter">
      <div class="applicationCenter-title">
        <div class="applicationCenter-title-left">应用中心</div>
        <div class="applicationCenter-title-right">
          <div class="applicationCenter-item-fanye">
            <div style="float:left" class="sedu-portal" @click="prea()">
              &#xe668;
            </div>
            <div
              style="float:left;margin-left:27px"
              class="applicationCenter-item-fanye1"
            >
              0{{ this.value + 1 }}
            </div>
            <div style="float:left">/</div>
            <div style="float:left" class="applicationCenter-item-fanye1">
              0{{ this.size }}
            </div>
            <div style="float:right" class="sedu-portal" @click="next()">
              &#xe667;
            </div>
          </div>
        </div>
      </div>
      <div class="applicationCenter-items">
        <Carousel v-model="value" loop arrow="never" dots="none">
          <CarouselItem v-for="count in number" :key="count">
            <div
              class="applicationCenter-item"
              :class="{ 'applicationCenter-item2': index < 3 }"
              v-for="(item, index) in list"
              :key="index"
              @click="jump(item)"
            >
              <div
                class="applicationCenter-item-img applicationCenter-item-img1"
              >
                <img
                  v-if="!item.image"
                  src="../../static/webp1/应用中心1@2x.webp"
                  alt=""
                />
                <img v-else :src="item.image" alt="" />
              </div>
              <div class="applicationCenter-item-content">
                <div class="applicationCenter-item-content-title">
                  {{ item.title }}
                </div>
                <div class="applicationCenter-item-content-content">
                  {{ item.description }}
                </div>
              </div>
            </div>
          </CarouselItem>
        </Carousel>
      </div>
    </div>
  </div>
</template>

<script>
import casjump from "../common/casjump";
export default {
  data() {
    return {
      navList: [],
      list: [],
      number: 0,
      begin: 0,
      end: 4,
      value: 0,
      size: 0
    };
  },
  mixins: [casjump],
  components: {},
  mounted() {
    this.getNav();
  },
  methods: {
    getNav() {
      GMS.$http
        .get("/appcenter/getAppCenter")
        .then(res => {
          if (res.status == 200) {
            this.navList = res.data;
            this.number = Math.ceil(res.data.length / 4);
            this.list = this.navList.slice(this.begin, this.end);
            this.size = this.navList.length;
          }
        })
        .catch(error => {
          this.$Message.error("获取数据异常，请联系管理员");
        });
    },

    prea() {
      if (this.value == 0) {
        return;
      }
      this.list = this.navList.slice(this.begin - 4, this.end - 4);
      this.begin = this.begin - 4;
      this.end = this.end - 4;
      this.value--;
    },
    next() {
      if (this.value == this.number - 1) {
        return;
      }
      this.list = this.navList.slice(this.begin + 4, this.end + 4);
      this.begin = this.begin + 4;
      this.end = this.end + 4;
      this.value++;
    },
    jump(item) {
      if (item.route) {
        if (item.withToken) {
          this.casjump(item.route);
        } else {
          window.open(item.route);
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.applicationCenter-wrap {
  width: 100%;
  margin-bottom: 70px;
  .applicationCenter {
    width: 1200px;
    margin: 0 auto;
  }
  @media screen and (max-width: 1500px) {
    .applicationCenter {
      width: 1200px;
    }
  }
  @media screen and (min-width: 1500px) and (max-width: 1800px) {
    .applicationCenter {
      width: 1400px;
    }
  }
  @media screen and (min-width: 1800px) {
    .applicationCenter {
      width: 1600px;
    }
  }
  .applicationCenter-title {
    height: 33px;
    margin-bottom: 50px;
    margin-top: 50px;
    .applicationCenter-title-left {
      float: left;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      font-size: 24px;
      color: #222222;
      letter-spacing: 0;
      line-height: 33px;
    }
    .applicationCenter-title-right {
      float: right;
      width: 138px;
      height: 28px;
      // border: 1px solid #E5E5E5;
      // border-radius: 14px;
      margin-top: 6px;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      text-align: center;
      line-height: 24px;
    }
  }
  .applicationCenter-items {
    height: 310px;
  }
  .applicationCenter-item {
    cursor: pointer;
    width: 262px;
    height: 305px;
    position: relative;
  }
  .applicationCenter-item2 {
    // margin-left: 48px;
    margin-right: 48px;
  }
  .applicationCenter-item3 {
    margin-right: 50px;
  }
  @media screen and (max-width: 1500px) {
    .applicationCenter-item {
      width: 262px;
      height: 305px;
    }
  }
  @media screen and (min-width: 1500px) and (max-width: 1800px) {
    .applicationCenter-item {
      width: 262px;
      height: 305px;
    }
    .applicationCenter-item2 {
      // margin-left: 110px;
      margin-right: 110px;
    }
    .applicationCenter-item3 {
      margin-right: 110px;
    }
  }
  @media screen and (min-width: 1800px) {
    .applicationCenter-item {
      width: 313px;
      height: 340px;
    }
    .applicationCenter-item2 {
      // margin-left: 110px;
      margin-right: 110px;
    }
    .applicationCenter-item3 {
      margin-right: 110px;
    }
    .applicationCenter-items {
      height: 340px;
    }
  }
  .applicationCenter-item {
    float: left;
    transition: All 0.2s ease-in-out;
    -webkit-transition: All 0.2s ease-in-out;
    -moz-transition: All 0.2s ease-in-out;
    -o-transition: All 0.2s ease-in-out;
  }
  .applicationCenter-item:hover {
    -webkit-transform: translateY(-5px);
    -moz-transform: translateY(-5px);
    transform: translatex(-5px);
  }
  .applicationCenter-item:hover .applicationCenter-item-img img {
    -webkit-transform: scale(1.2);
    -moz-transform: scale(1.2);
    -ms-transform: scale(1.2);
    transform: scale(1.2);
  }
  // .applicationCenter-item:hover {
  //     padding: 3px;
  //     box-shadow: 0 2px 21px 0 rgba(0,0,0,0.22);
  //     border-radius: 2px;
  //     transform: scale(1.1);
  //     -webkit-transform: scale(1.1);
  //     -moz-transform: scale(1.1);
  //     -o-transform: scale(1.1);
  //     -ms-transform: scale(1.1);
  // }
  // .applicationCenter-item:hover .applicationCenter-itemhover{
  //     width: 100%;
  //     height: 100%;
  //     position: absolute;
  //     border: 16px solid #fff;
  //     box-shadow: 0 2px 21px 0 rgba(0,0,0,0.22);
  // }

  .applicationCenter-item-img {
    height: 174px;
    overflow: hidden;
  }
  .applicationCenter-item-img img {
    width: 100%;
    height: 100%;
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
    -webkit-transition: -webkit-transform 0.2s;
    -moz-transition: -moz-transform 0.2s;
    -ms-transition: -moz-transform 0.2s;
    transition: transform 0.2s;
  }
  .applicationCenter-item-img1 {
    // background: url('../../static/webp1/应用中心1@2x.webp') no-repeat;
    // background-size: 262px 174px;
  }
  .applicationCenter-item-img2 {
    // background: url('../../static/webp1/应用中心2@2x.webp') no-repeat;
    // background-size: 262px 174px;
  }
  .applicationCenter-item-img3 {
    // background: url('../../static/webp1/应用中心3@2x.webp') no-repeat;
    // background-size: 262px 174px;
  }
  .applicationCenter-item-img4 {
    // background: url('../../static/webp1/应用中心4@2x.webp') no-repeat;
    // background-size: 262px 174px;
  }
  @media screen and (max-width: 1500px) {
    .applicationCenter-item-img1 {
      // background: url('../../static/webp1/应用中心1@2x.webp') no-repeat;
      // background-size: 262px 174px;
    }
    .applicationCenter-item-img2 {
      // background: url('../../static/webp1/应用中心2@2x.webp') no-repeat;
      // background-size: 262px 174px;
    }
    .applicationCenter-item-img3 {
      // background: url('../../static/webp1/应用中心3@2x.webp') no-repeat;
      // background-size: 262px 174px;
    }
    .applicationCenter-item-img4 {
      // background: url('../../static/webp1/应用中心4@2x.webp') no-repeat;
      // background-size: 262px 174px;
    }
  }
  @media screen and (min-width: 1500px) and (max-width: 1800px) {
    .applicationCenter-item-img1 {
      // background: url('../../static/webp1/应用中心1@2x.webp') no-repeat;
      // background-size: 262px 174px;
    }
    .applicationCenter-item-img2 {
      // background: url('../../static/webp1/应用中心2@2x.webp') no-repeat;
      // background-size: 262px 174px;
    }
    .applicationCenter-item-img3 {
      // background: url('../../static/webp1/应用中心3@2x.webp') no-repeat;
      // background-size: 262px 174px;
    }
    .applicationCenter-item-img4 {
      // background: url('../../static/webp1/应用中心4@2x.webp') no-repeat;
      // background-size: 262px 174px;
    }
  }
  @media screen and (min-width: 1800px) {
    .applicationCenter-item-img {
      height: 209px;
    }
    .applicationCenter-item-img1 {
      // background: url('../../static/webp1/应用中心1@2x.webp') no-repeat;
      // background-size: 313px 209px;
    }
    .applicationCenter-item-img2 {
      // background: url('../../static/webp1/应用中心2@2x.webp') no-repeat;
      // background-size: 313px 209px;
    }
    .applicationCenter-item-img3 {
      // background: url('../../static/webp1/应用中心3@2x.webp') no-repeat;
      // background-size: 313px 209px;
    }
    .applicationCenter-item-img4 {
      // background: url('../../static/webp1/应用中心4@2x.webp') no-repeat;
      // background-size: 313px 209px;
    }
  }
  .applicationCenter-item-content {
    height: 131px;
    .applicationCenter-item-content-title {
      height: 28px;
      line-height: 28px;
      margin-top: 20px;
      margin-bottom: 20px;
      font-weight: 500;
      font-size: 18px;
      color: #232323;
      letter-spacing: -0.08px;
    }
    .applicationCenter-item-content-content {
      font-weight: 400;
      font-size: 14px;
      color: #a4a4a4;
      letter-spacing: -0.06px;
      text-align: justify;
    }
  }
  .applicationCenter-item-fanye {
    width: 138px;
    height: 28px;
    float: left;
    line-height: 28px;
  }
  .applicationCenter-item-fanye1 {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 20px;
    color: #0081e9;
    letter-spacing: -0.08px;
    line-height: 30px;
  }
  .sedu-portal {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/applicationCenter.vue